import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveBounce32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveBounce32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M21.846 3.89a7.2 7.2 0 0 1 6.83 7.19l-.01.37a7.2 7.2 0 0 1-7.19 6.83l-.371-.01a7 7 0 0 1-1.067-.136l-3.778 6.983h9.577a1.2 1.2 0 0 1 0 2.4H6.159a1.2 1.2 0 0 1 0-2.4h4.545l-4.236-6.34a1.2 1.2 0 1 1 1.996-1.333l5.094 7.623 4.224-7.808a7.2 7.2 0 0 1-3.497-5.809l-.01-.37a7.2 7.2 0 0 1 7.2-7.2zm-.37 2.39a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6m-18.02 5.644a1.2 1.2 0 0 1 1.664.33l.757 1.133a1.2 1.2 0 0 1-1.996 1.334l-.757-1.132a1.2 1.2 0 0 1 .331-1.665"
            />
        </svg>
    );
}
export default memo(IconMoveBounce32);
